import { Formatter, Validation } from '@philips-emr/tws-core/lib/services/model-service';
import { isFunction } from '@philips-emr/tws-utils';

import { NumericFormatterFactoryOptions, NumericFormatterOptions } from './numeric-type';
import { addPrefix, createMask, isNumberValid, removePrefix } from './numeric-utils';

function createNumericFormatter(factoryOptions: NumericFormatterFactoryOptions): Formatter<string> {
  const {
    currency = false,
    formatterOptionTypes,
    invalidMessage,
    name,
    validate:
    customValidate,
    validatorOptionTypes,
    defaultOptions,
  } = factoryOptions;

  function format(value: number | string, userOptions: NumericFormatterOptions = {}): string {
    const { masked, options } = createMask(userOptions, defaultOptions);

    if (!value && value !== 0) {
      return String(value);
    }

    if (!isNumberValid(String(value), options)) {
      return addPrefix(String(value), currency);
    }

    if (typeof value === 'number') {
      masked.typedValue = value;
    } else {
      masked.unmaskedValue = value;
    }

    return addPrefix(masked.value, currency);
  }

  format.optionTypes = formatterOptionTypes;

  format.defaultOptions = defaultOptions;

  function parse(value: string, userOptions: NumericFormatterOptions = {}): string {
    const { masked, options } = createMask(userOptions, defaultOptions);

    masked.value = removePrefix(value, currency);

    if (isNumberValid(value, options)) {
      return masked.unmaskedValue;
    } else {
      return masked.value;
    }
  }

  function validate(value: string, userOptions: NumericFormatterOptions = {}): Validation[] {
    if (!value) {
      return [{ name, valid: true }];
    }

    const { masked, options } = createMask(userOptions, defaultOptions);

    masked.value = String(value);

    const isCustomValid = isFunction(customValidate) ? customValidate(value) : true;
    const isMaskValid = Boolean(masked.isComplete && masked.doValidate({}));
    const isValueValid = isNumberValid(value, options);

    const isValid = isCustomValid && isMaskValid && isValueValid;

    return [{
      name,
      valid: isValid,
      message: !isValid ? invalidMessage : '',
    }];
  }

  validate.optionTypes = validatorOptionTypes;

  return {
    parse,
    format,
    validate,
    getPattern: () => '',
  };
}

export default createNumericFormatter;
